import styled, { css } from 'styled-components';


export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin:0px;
  `}
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    justify-content: space-between;
    margin-top: 24px;
    padding: 16px 32px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
    }
  `}
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1 1 250px;
`;

export const CardTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 24px 0px 0px 0px;
  `}
`;

export const CardDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 16px 0px 0px 0px;
    text-align: center;
  `}
`;

export const ButtonWrapper = styled.div`
    align-items: center;
    display: inline-flex;
    justify-content: center;
    margin: 0px;
`;
